export default __webpack_public_path__ + "static/media/Shot_19.0000.858d4a97.png";